export default {
  // baseurl: 'https://testdigitalize.cnweisou.net',
  //  baseurl: 'https://digitization.5g-center.com',
  baseurl:'https://tapi.360ep.cn'
};

export const imgUrlHead = 'https://boweisou.oss-cn-shenzhen.aliyuncs.com/admin2.0/';
